export function isKey<T extends object>(x: T | undefined, k: PropertyKey): k is keyof T {
  try {
    if (!x) return false

    return k in x
  } catch {
    return false
  }
}
